module.exports = __webpack_public_path__ + "static/media/Faixada.f3006ad3.jpg";